import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=a35717da&scoped=true&"
import script from "./Single.vue?vue&type=script&lang=js&"
export * from "./Single.vue?vue&type=script&lang=js&"
import style0 from "./Single.vue?vue&type=style&index=0&id=a35717da&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35717da",
  null
  
)

export default component.exports